import * as React from 'react';
import MainPage from './MainPage';

export default () => <MainPage/>;

